<template>
	<div class="wrapper">
		<parallax
			class="section page-header header-filter"
			:style="headerStyle"
		></parallax>
		<div class="main main-raised">
			<div class="section profile-content">
				<div class="container">
					<div class="description md-layout">
						<div class="md-layout-item md-size-50 mx-auto">
							<div class="profile">
								<div class="avatar">
									<img
										:src="img"
										alt="Amrei Schaal Psychologische Psychotherapeutin Profilbild"
										class="img-raised rounded-circle img-fluid"
									/>
								</div>
								<div class="name">
									<h3 class="title">Amrei Schaal</h3>
									<h6>Psychologische Psychotherapeutin</h6>
								</div>
							</div>
						</div>
						<div>
							<h4>So erreichen Sie mich: <br /></h4>
							<h3>
								Praxis f&uuml;r Psychotherapie<br />
								A. Schaal <br />
								Kleine Mantelgasse 16<br />
								69117 Heidelberg <br />
							</h3>
							<h4>
								Die Praxis liegt in der Heidelberger Altstadt
								zwischen Neckar und Fußgängerzone in der Nähe
								der Alten Universität. Sie ist sowohl mit dem
								Auto als auch mit öffentlichen Verkehrsmitteln
								gut erreichbar.<br/>
								Der Fußweg von öffentlichen
								Parkhäusern (z.B. Parkhaus P11) und Haltestellen
								(Marstallstraße, Universitätsplatz) beträgt ca.
								2 - 5 Minuten. Die Praxis befindet sich im
								Erdgeschoss und ist barrierefrei.
							</h4>
						</div>
					</div>
					<div class="description text-center"></div>
					<div class="profile-tabs">
						<tabs
							:tab-name="['Karte', 'Raum']"
							:tab-icon="['map', 'house']"
							plain
							nav-pills-icons
							color-button="info"
						>
							<template slot="tab-pane-1">
								<div id="karte" class="md-layout">
									<GoogleMap />
								</div>
							</template>
							<template slot="tab-pane-2">
								<div id="raum" class="md-layout">
									<div
										class="md-layout-item md-size-50 ml-auto"
									>
										<img
											:src="tabPane2[0].image"
											class="rounded"
										/>
										<img
											:src="tabPane2[2].image"
											class="rounded"
										/>
									</div>
									<div
										class="md-layout-item md-size-50 mr-auto"
									>
										<img
											:src="tabPane2[1].image"
											class="rounded"
										/>
									</div>
								</div>
							</template>
						</tabs>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Tabs } from "@/components";
import { GoogleMap } from "@/components";

export default {
	components: {
		Tabs,
		GoogleMap,
	},
	bodyClass: "profile-page",
	data() {
		return {
			tabPane2: [
				{
					image: require("@/assets/img/practice/enhanced/practice_05.jpeg"),
				},
				{
					image: require("@/assets/img/practice/enhanced/practice_04.jpeg"),
				},
				{ image: require("@/assets/img/practice/practice_03.jpeg") },
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{ image: require("@/assets/img/anfahrt.jpg") },
			],
		};
	},
	props: {
		header: {
			type: String,
			default: require("@/assets/img/benjamin-voros-unsplash-mountain-stars__.jpeg"),
		},
		img: {
			type: String,
			default: require("@/assets/img/faces/amrei_11_done_3_auto_x2_minified.jpeg"),
		},
	},
	computed: {
		headerStyle() {
			return {
				backgroundImage: `url(${this.header})`,
			};
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.section {
	padding: 0;
}

.profile-tabs::v-deep {
	.md-card-tabs .md-list {
		justify-content: center;
	}

	[class*="tab-pane-"] {
		margin-top: 3.213rem;
		padding-bottom: 50px;

		img {
			margin-bottom: 2.142rem;
		}
	}
}
</style>
